'use strict';

module.exports = Object.freeze({
    mother: 'mother',
    child: 'child',
    orphan: 'orphan',
});
